export const Footer = () => {
    return (
        <footer>
            <div className="container footer-inner social">
                <a
                    href="https://www.instagram.com/tinkrverse.io"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Instagram
                </a>
                <a
                    href="https://www.reddit.com/u/tinkrverse"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Reddit
                </a>
                {/* <a
                    href=""
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    Facebook
                    </a> */}
                <a
                    href="mailto:contact@tinkrverse.io"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Email
                </a>
                <div className="copyright">
                    <span id="copyright">
                        © <span id="year">2026</span>{" "}
                        <span id="site-title">TinkrVerse</span>
                    </span>
                </div>
            </div>
        </footer>
    );
};
